import * as secondary from './secondary.color';

export const yellow = [secondary.yellow, secondary.orangeDarker];
export const orange = [secondary.orange, secondary.roseDarker];
export const rose = [secondary.roseDark, secondary.chestnutDarker];
export const chestnut = [secondary.chestnut, secondary.jazzberryDarker];
export const jazzberry = [secondary.jazzberry, secondary.javaDarker];
export const java = [secondary.java, secondary.kimberlyDarker];
export const kimberly = [secondary.kimberly, secondary.blueDarker];
export const blue = [secondary.blue, secondary.azureDarker];
export const azure = [secondary.azure, secondary.pineDarker];
export const pine = [secondary.pine, secondary.azureDarker];
